import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatSelectModule } from '@angular/material/select';
import { LangSelectComponent } from './lang-select.component';



@NgModule({
  declarations: [
    LangSelectComponent,
  ],
  imports: [
    CommonModule,
    MatSelectModule,
  ],
  exports: [
    LangSelectComponent,
  ]
})
export class LangSelectModule { }
